import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const Collapse = ({
  title,
  children,
  defaultOpen = false,
  className = "",
  headerClassName = "",
  bodyClassName = "",
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(Boolean(defaultOpen));

  useEffect(() => {
    setIsOpen(Boolean(defaultOpen));
  }, [defaultOpen]);

  return (
    <div
      className={`border border-gray-200 shadow-md rounded-md ${className} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      <div
        onClick={() => !disabled && setIsOpen((prev) => !prev)}
        className={`w-full flex items-center justify-between px-4 py-3 text-left select-none ${
          disabled ? "" : "cursor-pointer"
        } ${headerClassName}`}
      >
        {title}
        <FontAwesomeIcon
          icon={isOpen ? faChevronUp : faChevronDown}
          className="text-gray-500"
          style={{ width: "14px", height: "14px" }}
        />
      </div>
      {isOpen && (
        <div className={`p-4 text-sm text-gray-700 ${bodyClassName}`}>
          {children}
        </div>
      )}
    </div>
  );
};

export default Collapse;
